<!-- Header Section -->
<div class="page-header">
    <div class="header-content">
        <div class="header-title">
            <i class="material-icons" style="color: #991F26;">assignment</i>
            <h1 class="redesign hide-on-small-only">Meine Aufträge ({{totalBurials}})</h1>
            <h2 class="redesign hide-on-med-and-up">Meine Aufträge ({{totalBurials}})</h2>
        </div>
        
        <div class="header-actions">
            <a id="openNewContractButton" (click)="onNewContractClick()" 
               *ngIf="!isLoading && isApplicationOnline" 
               class="new-contract-btn" style="background-color: #991F26; transition: all 0.3s ease;">
                <i class="material-icons" style="color: black;">add_circle_outline</i>
                <span class="hide-on-small-only">Neuer Auftrag</span>
                <span class="hide-on-med-and-up">Neu</span>
            </a>
            
            <a id="openNewContractButton" *ngIf="!isLoading && !isApplicationOnline" 
               class="offline-btn">
                <i class="material-icons" style="color: #991F26;">wifi_off</i>
                <span class="hide-on-small-only">Offline</span>
                <span class="hide-on-med-and-up">Off</span>
            </a>
        </div>
    </div>

    <!-- Loading Spinner -->
    <div class="juvo-spinner right" *ngIf="isLoading">
        <div class="preloader-wrapper big active">
            <div class="spinner-layer spinner-green-only">
                <div class="circle-clipper left">
                    <div class="circle"></div>
                </div>
                <div class="gap-patch">
                    <div class="circle"></div>
                </div>
                <div class="circle-clipper right">
                    <div class="circle"></div>
                </div>
            </div>
        </div>
    </div>
</div>



<!-- Filter and Search Section -->
<div class="filter-section">
    <div class="row space-between center">
        <div class="input-field col s12 m6 burial-input">
            <div class="location-select">
                <i class="material-icons" style="color: #991F26;">location_on</i>
                <select id="inputLocation" class="inputLocation browser-default" (change)="onLocationChange($event)">
                    <option value="0" selected>{{currentLocationName}}</option>
                    <option *ngFor="let location of locations" value="{{location.id}}">
                        {{location.bestatter}}
                    </option>
                </select>
            </div>
        </div>
        
        <div class="action-buttons">
            <button class="action-btn tooltipped hide-on-small-only" (click)="onImportContractClick()" 
                    *ngIf="!isLoading" data-tooltip="PDF Import" data-position="bottom">
                <i class="material-icons" style="color: #991F26;">file_upload</i>
            </button>
            
            <button class="action-btn tooltipped" (click)="onSearchClick()" 
                    *ngIf="!isLoading" data-tooltip="Aufträge suchen" data-position="bottom">
                <i class="material-icons" style="color: #991F26;">search</i>
            </button>
            <!--
            <button class="action-btn tooltipped" (click)="onFilterClick()" 
                    *ngIf="!isLoading" data-tooltip="Aufträge filtern" data-position="bottom">
                <i class="material-icons" style="color: #991F26;">filter_list</i>
            </button>
            -->
        </div>
    </div>
</div> 